import '../styles/index.scss';
import anime from 'animejs';
import lottie from 'lottie-web';
import $ from 'jquery';

import hanger from './animations/hanger/hanger.js';
import star from './animations/star/star.js';
import cotton from './animations/cotton/cotton.js';
import playTransition from './animations/transition/transition.js';
import Sneakerhead from './animations/sneakerhead/sneakerhead.js';
import AllAmerican from './animations/allAmerican/allAmerican.js';
import Active from './animations/active/active.js';
import Prep from './animations/prep/prep.js';
import Trendsetter from './animations/trendsetter/trendsetter.js';
import { slide, openMenu, goToSlide, closeModal, gotolink, showRecomendation } from './functions.js';

import left from '../images/left.png';
import right from '../images/right.png';

import './images.js';

import '../images/hamburger.png';
import '../images/cotton-logo.png';
import '../images/urban-logo.png';


window.slide = slide;
window.openMenu = openMenu;
window.goToSlide = goToSlide;
window.gotolink = gotolink;
window.closeModal = closeModal;
window.showRecomendation = showRecomendation;
window.currentSlide = 0;
window.isSliding = false;
window.moreInfoOpened = false;
window.sections = [ Sneakerhead, AllAmerican, Prep, Active, Trendsetter ];


//load all sections
AllAmerican.load();
Prep.load();
Active.load();
Trendsetter.load();

//setting active menu item;
$('.menu li').first().addClass('active');

$('.carousel-controls.left').css({cursor: 'url('+left+'), auto'});
$('.carousel-controls.right').css({cursor: 'url('+right+'), auto'});

var theWidth = Math.max($(window).width(), $(window).height()*1.6);
$('.bg-anim').css({width: theWidth});


const fadeIn = (target, duration, offset) => (
  {
    targets: target,
    opacity: [0,1],
    easing: 'linear',
    duration: duration,
    offset: offset
  }
);


const fadeOut = (target, duration, offset) => (
  {
    targets: target,
    opacity: [1,0],
    easing: 'linear',
    duration: duration,
    offset: offset
  }
);

//adding a timeline for preloader appearing animations.
anime.timeline().add({
    targets: '.cotton',
    opacity: [0,1],
    width: [0,'160px'],
    height: [0,'195px'],
    easing: 'linear',
    duration: 300
  })
  .add(fadeIn('.title', 500,'-=200'))
  .add(fadeIn('.subtitle', 400,'-=300'))
  .add(fadeIn('.hanger.top', 500))
  .add(fadeIn('.star.three', 500))
  .add(fadeIn('.hanger.bottom', 400,'-=200'))
  .add(fadeIn('.star.one', 400))
  .add(fadeIn('.star.two', 500, '-=200'));


  document.addEventListener('preload-done', function() {
    //start hanger animations
    var sneakerAnim;
    $('.carousel-controls').hide();
    anime.timeline()
        .add(fadeOut('.preloader .hanger.bottom', 400, '-=200'))
        .add(fadeOut('.preloader .hanger.top', 500))
        .add(fadeOut('.preloader .star.two', 250))
        .add(fadeOut('.subtitle', 500, '-=250'))
        .add({
          targets: '.cotton',
          opacity: 0, width: '102px', height: '121px',
          easing: 'linear', duration: 250
        })
        .add(fadeOut('.preloader .star.one', 250, '-=250'))
        .add(fadeOut('.preloader .star.three', 250, '-=100'))
        .add({
          targets: '.title',
          scale: 0.565, easing: 'linear', duration: 500,
          begin: function(anim) {
            $('.logo').hide(500);
          }
        })
        .add({
          targets: '.preloader',
          height: 140, easing: 'linear', duration: 500,
          offset: '-=500',
          complete: function(){
            anime(fadeIn('.hamburger', 500, '0'));
            anime(fadeIn('.cotton-logo', 500, '0'));
            anime(fadeIn('.urban-logo', 500, '0'));
            anime(fadeIn('.subtitle', 500, '2000'));
          }
        })
        .add({
          targets: '.brand',
          top: '20px', easing: 'linear', duration: 500,
          offset: '-=500',
          begin: function(anim) {
            playTransition();
          },
        })
        .add({
          targets: '.carousel',
          opacity: 1, easing: 'linear', duration: 250,
          update: function(anim) {
            if (anim.currentTime > 100 && !sneakerAnim) {
              sneakerAnim = Sneakerhead.load();
              $('.carousel-controls').show();
              $('.sneakerhead').addClass('current');
              $('.carousel-dots').css({opacity: 1});
            }
          }
        });
 });
